import React from 'react';

interface CpuComparisonRowProps {
  label: string;
  values: (string | number)[];
  isWhiteBackground?: boolean;
}

export default function CpuComparisonRow({
  label,
  values,
  isWhiteBackground = false
}: CpuComparisonRowProps) {
  const rowClassName = isWhiteBackground
    ? 'flex flex-row w-full h-[68px] items-center bg-white border-b border-gray-200'
    : 'flex flex-row w-full h-[68px] items-center bg-gray-50 border-b border-gray-200';

  return (
    <div className={rowClassName}>
      <div className="flex w-[380px] px-3xl items-center text-md font-regular leading-lg text-gray-900">
        {label}
      </div>
      {values.map((value, index) => (
        <div
          key={index}
          className="flex flex-1 justify-center items-center text-md font-semibold leading-lg text-gray-900"
        >
          {value}
        </div>
      ))}
    </div>
  );
}
